import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { render } from 'react-dom';

// material-ui
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { Grid, Typography } from '@mui/material';

// project imports
import MainCard from '../MainCard';
import _ from "lodash";

// ==============================|| BREADCRUMBS ||============================== //

const Breadcrumbs = ({ navigation, title, actionButtonAddSite, ...others }) => {
  const location = useLocation();
  const [main, setMain] = useState();
  const [item, setItem] = useState();

  // set active item state
  const getCollapse = (menu) => {
    ////console.log(menu)
    if (menu.children) {
      menu.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse);
        } else if (collapse.type && collapse.type === 'item') {
          if (location.pathname === collapse.url) {
            setMain(menu);
            setItem(collapse);
          }
        }
        return false;
      });
    }
  };



  useEffect(() => {
    navigation?.items?.map((menu) => {
      if (menu.type && menu.type === 'group') {
        getCollapse(menu);
      }
      return false;
    });
  });

  // //console.log(navigation)
  // //console.log(location.pathname)

  // only used for component demo breadcrumbs
  // if (location.pathname === '/createPMA') {
  //   location.pathname = '/PropertyManager/createPMA';
  // }

  let mainContent;
  let itemContent;
  let breadcrumbContent = <Typography />;
  let itemTitle = '';

//first level menu generating after HOME
  const itemArr = item && item?.url.indexOf('/')>-1 &&  item.url.split('/');

  if (item && item.type === 'item' && item.level==2 && itemArr && itemArr.length>1) {
    let parentUlr='/' + itemArr[1];
    main.children.map((collapse) => {
    if (collapse.type && collapse.type === 'item') {
        if ( collapse.url == parentUlr) {
          mainContent = (
            <Typography component={Link} to={collapse.url} variant="link" sx={{ textDecoration: 'none' }} >
              {collapse.navTitle}
            </Typography>
            
          );
        }
      }
      
    });
   
  }
  // items
  if (item && item.type === 'item' ) {
    itemTitle = item.navTitle;
    //console.log(item.visibility)
    itemContent = (
      <Typography variant="label">
        {itemTitle}
      </Typography>
      
    );
    
    // main
    if (item.breadcrumbs !== false )  {
      breadcrumbContent = (
        <MainCard border={false} sx={{ mb: 3, bgcolor: 'transparent' }} {...others} content={false}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
            <Grid item>
              <MuiBreadcrumbs aria-label="breadcrumb">
                <Typography component={Link} to="/default"  variant="link" sx={{ textDecoration: 'none' }}>
                  Home
                </Typography>
                {mainContent}
                {itemContent}
              </MuiBreadcrumbs>
            </Grid>
            {title && (
              <Grid item sx={{ mt: 2 }}>
                <Typography variant="label">{item.title}</Typography>
              </Grid>
            )}
            
            {/* <div>{render(actionButtonAddSite)}</div> */}
          </Grid>
        </MainCard>
      );
    }
  }

  return breadcrumbContent;
};

Breadcrumbs.propTypes = {
  navigation: PropTypes.object,
  title: PropTypes.bool
};

export default Breadcrumbs;
